import { render, staticRenderFns } from "./KitItemForm.vue?vue&type=template&id=1754f2fd"
import script from "./KitItemForm.vue?vue&type=script&lang=js"
export * from "./KitItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports